export default __webpack_public_path__ + "static/media/sm_traffic_lights.4aab1d72.gif";